// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorComponent_error__1bQmC","title":"ErrorComponent_title__2kuC4"};